import * as authentActionType from '@lib/actions/AuthenticationActionType';
import * as siteActionType from '@lib/actions/SiteActionType';
import { Action, Reducer } from "redux";
import { ISite, IStoreSiteState } from "types";




/**
 * Reducer to handle action about sites
 * @param state 
 * @param action 
 */
export const siteReducer: Reducer<IStoreSiteState> = (state: IStoreSiteState, action: Action) => {
  if (state === undefined) {
    return { pendingOrder: 0 };
  }
  let act;
  let outputs;
  let idOutput;
  switch (action.type) {
    case siteActionType.SITE_SESSION_EXPIRED:
      window.location.hash = '';
      return state;
    case authentActionType.SIGN_IN_ACTION:
      act = (action as authentActionType.ISignInAction);
      if (act.error) {
        return state;
      } else {
        window.location.hash = 'home';
        return { ...state, "sites": act.payload!.sites };
      }
    case siteActionType.SITE_SELECT_ACTION:
      if (state.pendingOrder > 0 || state.syncing) {
        return state;
      }
      act = (action as siteActionType.ISiteSelectAction);
      if (act.payload!.forceNavigateToDashboard) {
        window.location.hash = 'dashboard';
      }
      let syncing = state.syncing;
      let pendingOrder = state.pendingOrder;
      if (state.site && state.site!.device && state.site!.device!.id !== act.payload!.site!.device!.id) {
        syncing = false;
        pendingOrder = 0;
      }
      return {
        ...state, 'errorMessage': '', 'pendingOrder': pendingOrder, saving: false,
        'site': act.payload!.site, 'syncing': syncing,
      };
    case siteActionType.SITE_START_SYNCINGACTION:
      return {
        ...state, 'syncing': true,
      };
    case siteActionType.SITE_SYNC_ACTION_START:
      return { ...state, 'syncing': true };
    case siteActionType.SITE_SAVE_ACTION_START:
      return { ...state, saving: true };
    case siteActionType.SITE_SYNC_ACTION_FINISH:
      act = (action as siteActionType.ISiteSyncAction);
      return { ...state, 'errorMessage': act.payload.errorMessage, 'syncing': false };
    case siteActionType.SITE_ADD_ACTION_FINISH:
      act = (action as siteActionType.ISiteAddAction);
      return { ...state, 'errorMessage': act.payload!.errorMessage };

    case siteActionType.SITE_LIST_ACTION_FINISH:
      act = (action as siteActionType.ISiteListAction);
      if (window.location.hash !== '#/home') {
        window.location.hash = 'home';
      }
      return { ...state, 'sites': act.payload!.sites! };
    case siteActionType.SITE_OUTPUT_CHANGE_START:
      outputs = state.site!.outputs!;
      act = (action as siteActionType.IOutputChangedAction);
      idOutput = (action as siteActionType.IOutputChangedAction).payload.idOutput;
      for (const output of outputs) {
        if (output.no === idOutput) {
          output.value = 2
        };
      };
      return {
        ...state, "pendingOrder": state.pendingOrder + 1, site: { ...state.site!, outputs }
      };
    case siteActionType.SITE_OUTPUT_CHANGED:
      // Just retrun the state, the change has been done, 
      // wait the next retrieval to update the state of the output
      act = (action as siteActionType.IOutputChangedAction);
      return {
        ...state, 'errorMessage': act.payload.errorMessage, 'pendingOrder': state.pendingOrder - 1,
      };
    case siteActionType.SITE_EDIT_TEMPERATURE_NAVIGATE_ACTION:
      act = (action as siteActionType.IEditTemperatureNavigateAction);
      if (state.site === undefined || state.site.temps === undefined) { return state; }
      for (const temp of state.site!.temps!) {
        if (temp.no === act.payload.no) {
          window.location.hash = 'temperature';
          return {
            ...state, temp
          };
        }
      }
      // Temp no not found, must not arrive
      return state;
    case siteActionType.SITE_EDIT_THERMOSTAT_NAVIGATE_ACTION:
      act = (action as siteActionType.IEditTemperatureNavigateAction);
      if (state.site === undefined || state.site.temps === undefined) { return state; }
      for (const temp of state.site!.temps!) {
        if (temp.no === act.payload.no) {
          window.location.hash = 'thermostat';
          return {
            ...state, temp
          };
        }
      }
      // Temp no not found, must not arrive
      return state;
    case siteActionType.SITE_EDIT_OUTPUT_NAVIGATE_ACTION:
      act = (action as siteActionType.IEditOutputNavigateAction);
      if (state.site === undefined || state.site.outputs === undefined) { return state; }
      for (const output of state.site!.outputs!) {
        if (output.no === act.payload.no) {
          window.location.hash = 'output';
          return {
            ...state, output
          };
        }
      }
      // Output no not found, must not arrive
      return state;
    case siteActionType.SITE_EDIT_INPUT_NAVIGATE_ACTION:
      act = (action as siteActionType.IEditOutputNavigateAction);
      if (state.site === undefined || state.site.inputs === undefined) { return state; }
      for (const input of state.site!.inputs!) {
        if (input.no === act.payload.no) {
          window.location.hash = 'input';
          return {
            ...state, input
          };
        }
      }
      // Input no not found, must not arrive
      return state;
    case siteActionType.SITE_CHANNEL_SAVE:
      act = (action as siteActionType.IChannelSaveAction);
      return { ...state, 'errorMessage': act.payload.errorMessage, 'saving': false };
    case siteActionType.SITE_RECIPIENTS_SAVE:
      return state;
    case siteActionType.SITE_SCHEDULES_SAVE:
      window.location.hash = 'thermostat';
      return { ...state, 'saving': false };
    case siteActionType.SITE_ADD_ACTION_START:
      return { ...state, 'errorMessage': '' };
    case siteActionType.SITE_DASHBOARD_NAVIGATE_ACTION:
      window.location.hash = 'dashboard';
      return { ...state, 'errorMessage': '', 'successMessage': '' };
    case siteActionType.SITE_EDIT_NAVIGATE_ACTION:
      act = (action as siteActionType.ISiteEditNavigateAction);
      const site: ISite = { name: act.payload.name };
      site.device = { id: act.payload.id, mac: '' };
      window.location.hash = 'siteEdit';
      return { ...state, 'site': site, 'errorMessage': '' };
    case siteActionType.SITE_UPDATE_ACTION_FINISH:
      act = (action as siteActionType.IChannelSaveAction);
      return { ...state, 'errorMessage': act.payload.errorMessage };
    case siteActionType.FIRMWARE_VERSION_ACTION_FINISH:
      act = (action as siteActionType.IFirmwarVersionAction);
      return { ...state, lastM1: act.payload!.m1, lastM2: act.payload!.m2, };
    case siteActionType.PUSH_SUBSCRIBE_FINISH:
      act = (action as siteActionType.IPushAction);
      return { ...state, push: act.payload.subscribed };
    // case siteActionType.DEVICE_REGISTERED:
    //   act = (action as siteActionType.IDeviceRegisteredAction);
    //   let pushSubscribedForTheDevice = false;
    //   if (state.pushDevices !== undefined) {
    //     for (const dev of state.pushDevices!) {
    //       if (dev.token === act.payload.token) {
    //         pushSubscribedForTheDevice = true;
    //         break;
    //       }
    //     }
    //   }
    //   return { ...state, token: act.payload.token, push: pushSubscribedForTheDevice };
    case siteActionType.PUSH_DEVICES_OF_USER:
      act = (action as any);
      return { ...state, pushDevices: act.payload.pushDevices };
    case siteActionType.ALARM_LIST_ACTION_FINISH:
      act = (action as siteActionType.IAlarmListAction);
      if (window.location.hash !== '#/alarm') {
        window.location.hash = 'alarm';
      }
      return { ...state, alarm: act.payload!.alarm, 'syncing': false, };
    case siteActionType.LOGEVENT_LIST_ACTION_FINISH:
      act = (action as siteActionType.ILogEventListAction);
      if (!act.payload!.error && window.location.hash !== '#/logEvent') {
        window.location.hash = 'logEvent';
      }
      return { ...state, logEvent: act.payload!.logEvent, 'syncing': false, };

    case siteActionType.USER_LIST_ACTION_FINISH:
      act = (action as siteActionType.IUserListAction);
      if (window.location.hash !== '#/user') {
        window.location.hash = 'user';
      }
      return { ...state, user: act.payload!.user, 'syncing': false, };
    case siteActionType.SITE_RECIPIENT_TEST_START:
      return { ...state, 'errorMessage': '', 'successMessage': '' };
    case siteActionType.SITE_RECIPIENT_TEST_FINISH:
      return { ...state, 'errorMessage': '', 'successMessage': 'testSent' };
    case siteActionType.SITE_RECIPIENT_TEST_ERROR:
      act = (action as siteActionType.IRecipientsTestAction);
      return { ...state, 'errorMessage': act.payload.errorMessage, 'successMessage': '' };
    case siteActionType.WORKING_START:
      return { ...state, 'working': true };
    case siteActionType.WORKING_STOP:
      return { ...state, 'working': false };
    case siteActionType.SITE_TIME_OUT:
      return { ...state, 'working': false, 'errorMessage': '', 'successMessage': '', saving: false, syncing: false };
    case siteActionType.PUSH_TOKEN_SUCCESS:
      act = (action as siteActionType.ITokenAction);
      let push: boolean = false;
      if (state.pushDevices !== undefined) {
        for (const dev of state.pushDevices!) {
          if (dev.token === act.payload.token) {
            push = true;
            break;
          }
        }
      }
      return { ...state, token: act.payload.token, push }
    default:
      return state;
  }

}


// WEBPACK FOOTER //
// ./src/reducers/siteReducer.tsx